export const config = {
  cookieName: "video_modal",
  cookieDismissedValue: "dismissed",
  dismissalDays: 365
};
